import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import angular from 'angular';

export const NavigationDirectiveModule = angular.module('acme.common.directive.header.navigation', [
  ThemesServiceModule,
  HelpersServiceModule
])
.directive('headerNavigation', ['HelpersService', function(HelpersService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/header/navigation/navigation.tpl.html',
      scope: {},
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', 'ThemesService', function($scope, ThemesService) {

        $scope.headerNavigation = {
          links: [],

          init: function() {
            this.links = ThemesService.getLinks();
            for (var key in this.links) {
              this.links[key].link = this.links[key].link + HelpersService.addDonationParams();
            }
          }

        };

        $scope.headerNavigation.init();

      }]

    };

}]).name;
